import { render, staticRenderFns } from "./ElenaHernandez.vue?vue&type=template&id=31047641&scoped=true"
import script from "./ElenaHernandez.vue?vue&type=script&lang=js"
export * from "./ElenaHernandez.vue?vue&type=script&lang=js"
import style0 from "./ElenaHernandez.vue?vue&type=style&index=0&id=31047641&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31047641",
  null
  
)

export default component.exports